import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'btn-text',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './btn-text.component.html',
  styleUrls: ['./btn-text.component.css'],
})
export class BtnTextComponent {
  // Inputs using Signals (Angular 17+ pattern)
  label = input<string>('Submit');
  prefixIcon = input<string>();
  bgColor = input<string>('bg-transparent');
  bgDisabledColor = input<string>('bg-primary-100');
  textColor = input<string>('text-primary-200');
  fontSize = input<string>('text-sm');
  textHoverColor = input<string>('text-primary-500');
  addClasses = input<string>('');

  // Inputs using traditional @Input
  @Input() isDisabled: Observable<boolean> = of(false);
  @Input() isLoading: Observable<boolean> = of(false);

  @Output() onClick = new EventEmitter<void>();

  handleClick(): void {
    this.onClick.emit();
  }
}
